module.exports = __webpack_public_path__ + "static/img/Jason-Cummings.bd83e16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jason-Cummings.jpg
// module id = MOKN
// module chunks = 0